import { Link } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import { nanoid } from 'nanoid';
import classes from './style/ThemeTestComponent.module.css';
import { Button, Form, Input, Select } from 'antd';
import { ApiCenter } from '../../api/ApiCenter';
import TestCard from './TestCard/TestCard';
import { Roles } from '../../../types/GlobalEnum';
import { RoleComponentRender, UI_Pagination } from '../../../Core/Core';
import { DataTest, ITest } from '../../../types/TestType';
const ThemeTestComponent = () => {
  const [data, setData] = useState<DataTest>();
  const [form] = Form.useForm();
  const prevValueRef = useRef<string>();
  const Apistart = new ApiCenter();
  const timerRef = useRef<NodeJS.Timeout | undefined>();
  const { HRNYA, SUPER_ADMIN } = Roles;
  const [activeButton, setActiveButton] = useState<string>('all');
  const cardsPerPage = 12;

  const [currentPage, setCurrentPage] = React.useState(1);
  const totalPages = data?.tests ? Math.ceil(data.tests.length / cardsPerPage) : 0;

  const paginatedDepartments = data?.tests?.slice(
    (currentPage - 1) * cardsPerPage,
    currentPage * cardsPerPage
  );
  const [filterTests, setFilterTests] = useState<{
    category_id: number;
    isDraft: boolean | null;
    is_attestation: boolean | null;
    title: string;
  }>({
    category_id: 1,
    isDraft: null,
    is_attestation: null,
    title: '',
  });

  const constructLink = () => {
    const baseUrl = 'hr/test';
    let link = baseUrl;
    if (filterTests.is_attestation !== true) {
      link += filterTests.category_id !== 1 ? `?category_id=${filterTests.category_id}` : '';
      link +=
        filterTests.title !== ''
          ? (filterTests.category_id !== 1 ? '&title=' : '?title=') + filterTests.title
          : '';
      link += filterTests.isDraft
        ? (filterTests.category_id !== 1 || filterTests.title !== ''
            ? '&is_draft='
            : '?is_draft=') + filterTests.isDraft
        : '';
    } else {
      link += '?is_attestation=true';
    }
    return link;
  };

  const fetchData = async (link: string) => {
    try {
      const response = await Apistart.GET_API(link, 'GET');
      if (response.success) {
        setData(response.data);
      } else {
        // eslint-disable-next-line no-console
        console.error();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData(constructLink());
  }, [filterTests]);
  const handlePageChange = (newPage: number | null, decr?: boolean, increm?: boolean) => {
    if (newPage) {
      setCurrentPage(newPage);
    }
    if (decr) {
      setCurrentPage((prev) => (prev -= 1));
    }
    if (increm) {
      setCurrentPage((prev) => (prev += 1));
    }
  };
  const handleChange = (value: number) => {
    setFilterTests(() => ({ ...filterTests, category_id: value, is_attestation: false }));
    setActiveButton('');
  };
  const handleModeChange = (value: string) => {
    setFilterTests(() => ({ ...filterTests, isDraft: value === 'draft', is_attestation: false }));
    setActiveButton(value);
  };
  const isAttestationSwitch = () => {
    setFilterTests(() => ({ ...filterTests, is_attestation: true }));
    setActiveButton('attestation');
  };
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.value !== prevValueRef.current) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      prevValueRef.current = event.currentTarget.value;
      if (prevValueRef.current) {
        timerRef.current = setTimeout(() => {
          setFilterTests({
            ...filterTests,
            is_attestation: false,
            title: prevValueRef.current ? prevValueRef.current : event?.currentTarget?.value,
          });
          setActiveButton('');
        }, 800);
      } else {
        setFilterTests({ ...filterTests, title: '' });
        setActiveButton('');
      }
    }
  };
  const themeDelete = async (e: React.MouseEvent<HTMLElement, MouseEvent>, id: number) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const response = await Apistart.GET_API(`hr/test/${id}`, 'DELETE');
      if (response.success) {
        fetchData(constructLink());
      } else {
        // eslint-disable-next-line no-console
        console.error();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  return (
    <>
      <div className={classes.HeaderTitle}>
        <div
          style={{
            width: '93%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>Тесты</div>
          <div>
            <RoleComponentRender roles={[HRNYA, SUPER_ADMIN]}>
              <Button type="primary">
                <Link style={{ color: 'white' }} to={`creating-test`}>
                  + Создать тематический тест
                </Link>
              </Button>
              {/* <Button type="primary">
                <Link style={{ color: 'white' }} to={`creating-test`}>
                  + Добавить вопросы в категорию
                </Link>
              </Button> */}
            </RoleComponentRender>
          </div>
        </div>
      </div>
      <div>
        <Form form={form} autoComplete="off" layout="vertical">
          <div style={{ display: 'flex', gap: '2%' }}>
            {data?.categories && (
              <Form.Item
                style={{ width: '30%' }}
                label="Категория"
                name="category_id"
                initialValue={1}
              >
                <Select placeholder="Категория урока" onChange={handleChange}>
                  <Select.Option value={1}>Все</Select.Option>
                  {data.categories.map((item) => {
                    return (
                      <Select.Option value={item?.id} key={item?.id}>
                        {item?.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            )}
            <Form.Item style={{ width: '61%' }} label="Поиск по названию">
              <Input
                placeholder="Поиск..."
                prefixCls=""
                suffix={<SearchOutlined />}
                onChange={handleSearch}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
      <div className={classes.buttonWrapper}>
        <Button
          style={{
            border: activeButton === 'all' ? '1px solid #CCC' : 'none',
            backgroundColor: 'none',
            padding: '0 30px 0 30px',
          }}
          onClick={() => handleModeChange('all')}
        >
          Все
        </Button>
        <Button
          style={{
            border: activeButton === 'thematic' ? '1px solid #CCC' : 'none',
            backgroundColor: 'none',
          }}
          onClick={() => handleModeChange('thematic')}
        >
          Тематические
        </Button>
        <Button
          style={{
            border: activeButton === 'attestation' ? '1px solid #CCC' : 'none',
            backgroundColor: 'none',
          }}
          onClick={isAttestationSwitch}
        >
          Аттестационные
        </Button>
        <Button
          style={{
            border: activeButton === 'draft' ? '1px solid #CCC' : 'none',
            backgroundColor: 'none',
          }}
          onClick={() => handleModeChange('draft')}
        >
          Черновики
        </Button>
      </div>

      <div className={classes.Wrapper}>
        {data &&
          paginatedDepartments?.map((test: ITest) => {
            const id = nanoid();
            return (
              <div key={id}>
                <TestCard
                  category_title={
                    filterTests.is_attestation
                      ? test.title
                      : data?.categories?.[test?.theme?.category_id - 2]?.['title'] || ''
                  }
                  title={test.title}
                  questions_count={test.questions_count}
                  id={test.id}
                  isButtonDelete={filterTests.is_attestation ? false : true}
                  themeDelete={themeDelete}
                />
              </div>
            );
          })}
      </div>
      {totalPages > 1 && (
        <UI_Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      )}
    </>
  );
};
export default ThemeTestComponent;
